import React from 'react';
import {Link} from "react-router-dom";

const BreadCrumbsItem = ({title, path, isActive}) => {
  return (
    <Link to={path} className={`bread-crumbs__item ${isActive ? 'active' : ''}`}>{title}</Link>
  );
};

export default BreadCrumbsItem;